import useUserData from './useUserData';

import { USER_ROLES } from '../constants/main.js';

export default function useUserRole() {
  const { user, isFetching } = useUserData();

  return {
    role: user?.role,
    isSuperAdmin: user?.isSuper,
    isOwner: user?.role === USER_ROLES.owner,
    isLoanOfficer: user?.role === USER_ROLES.loanOfficer,
    isAdministrative: user?.role === USER_ROLES.administrative,
    isFetching,
  };
}
